module.exports = __webpack_public_path__ + "img/404.1f3fa99e.png";